// @ts-nocheck
import { useState, useEffect, useContext } from 'react';
import { useSession } from '@/hooks/useSession'
import { createFileRoute } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";
import { useParams } from "@tanstack/react-router";
import { usePlaceList } from "@/services/usePlaceList";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useUserList } from '@/services/useUserList';
import { useUserAdd } from '@/services/useUserAdd';
import { useUserRemove } from '@/services/useUserRemove';
import { VelContext } from "@/contexts/VelContext";
import { NEW_BACKOFFICE_URL } from "@/lib/constants";

import Offers from '@/components/offer/Offers';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import Badge from '@/components/ui/Badge';
import { PlusCircleIcon, Shield, ShieldUser } from 'lucide-react';
import { Input } from '@/components/ui/input';


export const Route = createFileRoute("/vel/$velId/")({
  component: RouteComponent,
});


function RouteComponent() {
  const { velId } = useParams({ strict: false });
  const vels = useContext(VelContext);

  useEffect(() => {
    if (vels) {
      const vel = vels.find((v) => v.id === Number(velId));
      if (vel?.migrated === 1) {
        window.location.href = `${NEW_BACKOFFICE_URL}/vel/${velId}`;
      }
    }
  }, [vels, velId]);

  return (
    <Tabs defaultValue='places'>
      <TabsList>
        <TabsTrigger value="places">Clubs</TabsTrigger>
        <TabsTrigger value="users">Utilisateurs</TabsTrigger>
        <TabsTrigger value="offers">Bannières</TabsTrigger>
      </TabsList>
      <TabsContent value='places'>
        <Places velId={velId} />
      </TabsContent>
      <TabsContent value='users'>
        <Users velId={velId} />
      </TabsContent>
      <TabsContent value='offers'>
        <Offers velId={velId} />
      </TabsContent>
    </Tabs>
  )
}

function Users({velId}) {
  const users = useUserList({ velId });
  const session = useSession();
  const {mutate: userRemove} = useUserRemove({velId});

  if (users.isPending) return <div>Loading</div>;
  if (!users.isSuccess) return <div>Error</div>;

  const removeUser = (e, user ) => {
    e.preventDefault();
    if(!window.confirm(`Supprimer ${user.email} ?`))
      return;

    userRemove(user.id);
  }
  return (
    <div className="m-4">
      <h1 className="font-bold text-5xl mb-8">Utilisateurs</h1>
      <div className="rounded-md border bg-white ">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Id</TableHead>
              <TableHead>Nom</TableHead>
              <TableHead>Email</TableHead>
              {session.user?.isAdmin && <TableHead>Action <ShieldUser className="inline" /></TableHead>}
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={session.user?.isAdmin ? 4 : 3} className="text-center">
                  Aucun utilisateur n'est enregistré. <br/>
                  Seuls les administrateurs MSDS peuvent accéder à ce tunnel.
                </TableCell>
              </TableRow>
            ) : (
              users.data.map((user) => {
                return (
                  <TableRow
                    key={user.id}
                    className="cursor-pointer"
                  >
                    <TableCell>{user.id}</TableCell>
                    <TableCell>{user.firstname} {user.lastname}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    {session.user?.isAdmin && (
                      <TableCell>
                        <Button onClick={ e => removeUser(e, user)}>Supprimer</Button>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </div>
      <UserAdd velId={velId}/>
    </div>
  );
}

function UserAdd({velId}) {
  const session = useSession();
  const [email, emailSet] = useState('');
  const {mutate: userAdd} = useUserAdd({velId});

  const addUser = e => {
    e.preventDefault();
    userAdd({email: email});
    emailSet('');
  };

  if( !session.user?.isAdmin )
    return null;

  return (
    <div className="rounded-md border bg-white mt-5 p-2">
      <h2 className="font-bold text-2xl mb-2">Ajouter un utilisateur <ShieldUser className="inline" /></h2>
      <form>
        <Input type='text' value={email} placeholder='Adresse e-mail' onChange={e => emailSet(e.target.value.trim())} className='mb-2' />
        <Button onClick={addUser}>
          <PlusCircleIcon className="inline" />
          Ajouter
        </Button>
      </form>
    </div>
  )
}

function Places({velId}) {
  const navigate = useNavigate();
  const places = usePlaceList({ velId, withStats: true });

  if (places.isPending) return <div>Loading</div>;
  if (!places.isSuccess) return <div>Error</div>;
  if (!places.data.length) return <div></div>;

  return (
    <div className="m-4">
      <h1 className="font-bold text-5xl mb-8">Choisissez votre club</h1>
      <div className="rounded-md border bg-white ">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Id</TableHead>
              <TableHead>Nom</TableHead>
              <TableHead className='text-center'>État</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {places.data.map((place, index: number) => {
              return (
                <TableRow
                  key={`${place.name}-${index}`}
                  className="cursor-pointer"
                  onClick={() =>
                    navigate({
                      to: `./place/${place.msdsId}`,
                    })
                  }
                >
                  <TableCell>{place.msdsId}</TableCell>
                  <TableCell>{place.name}</TableCell>
                  <TableCell className='text-center'>
                    {place.enabled === 0 && (
                      <Badge variant="red" className='mr-2'>
                        Désactivé
                      </Badge>
                    )}
                    <Badge variant={place.stats.nb_products_enabled > 0 ? "green" : "gray"}>
                      Actives : {place.stats.nb_products_enabled}
                    </Badge>
                    &nbsp;
                    <Badge variant={place.stats.nb_products_missing_config > 0 ? "orange" : "gray"}>
                      Non configurées : {place.stats.nb_products_missing_config}
                    </Badge>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
